import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { CtButtonModule } from '@ctsolution/ct-framework';

import { UserChangePasswordDialogComponent } from './user-change-password-dialog.component';

/**
 * Modulo per il dialog di cambio password utente
 * Importa tutti i moduli necessari per il funzionamento della modale
 */
@NgModule({
  declarations: [
    UserChangePasswordDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    CtButtonModule
  ],
  exports: [
    UserChangePasswordDialogComponent
  ]
})
export class UserChangePasswordDialogModule { }
